import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import Holiday from '../../../../components/modules/hr/holiday';
import HolidayMiddleware from '../../../../middleware/modules/hr/holiday';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,holiday }) => ({
  isProcessing: holiday.isProcessing,
  isError: holiday.isError,
  errorMessage: holiday.errorMessage,
  datalist:holiday.data,
  showModal:holiday.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>HolidayMiddleware.create(),
    reset: () =>HolidayMiddleware.resetList(),
    search: data =>HolidayMiddleware.list(data),
    update: data =>HolidayMiddleware.update(data),
    delete: (id,search) =>HolidayMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class HolidayContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.update(id)
  }
  createItem(){
    this.props.create()
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Holiday List")}
          </title>
        </Helmet>
      <Holiday
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HolidayContainer);
